import React from 'react';
import PropTypes from 'prop-types';

import { getSetting } from '../helpers/Settings';

const LoginSSOButton = ({ profile }) => (
  <div className={`login-saml login-saml-${getSetting('saml_login_button_position')}`}>
    <a
      href={profile.client.saml_login_url}
      className={`btn btn-${getSetting('saml_login_button_style')}`}
      title={getSetting('saml_login_button_text')}
      tabIndex="-1"
    >
      {getSetting('saml_login_button_icon') && (
        <i className={`fas fa-${getSetting('saml_login_button_icon')} mr-2`} />
      )}
      {getSetting('saml_login_button_text')}
    </a>
  </div>
);

LoginSSOButton.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default LoginSSOButton;
